import { Props_StayInTouch } from "./stayInTouch.props"
import { Legacy_CompileMarkdown } from "@ClientBase/React/ReactSnippetMDCompiler"

export const StayInTouch = (props: Props_StayInTouch) => {
    const { heading, image, content, link, orientation } = props;
    console.log(props);
    return (
        <section className={`attrax-stay-in-touch ${orientation.layout.value === 'right' ? 'attrax-stay-in-touch--image-right' : ''}`}>
            <div className="attrax-stay-in-touch__container">
                <div className="attrax-stay-in-touch__wrapper">
                    <figure className="attrax-stay-in-touch__image-container">
                        {image.source?.value && (
                            <img
                                src={image.source.value}
                                alt={image.alt?.value || ""}
                                className="attrax-stay-in-touch__image"
                                loading="lazy"
                            />
                        )}
                    </figure>
                    <div className='attrax-stay-in-touch__content-area'>
                        <div className="attrax-stay-in-touch__content">
                            {heading.text?.value && (
                                <h3 className="attrax-stay-in-touch__content-heading">
                                    <span>{heading.text.value}</span>{heading.highlightedText.value}
                                </h3>
                            )}

                            {content.text?.value && (
                                <div className="attrax-stay-in-touch__content-text">
                                    {Legacy_CompileMarkdown(content.text.value)}
                                </div>
                            )}

                            {link.url?.value && link.text?.value && (
                                <a
                                    href={link.url.value}
                                    className="attrax-stay-in-touch__link"
                                    aria-label={link.ariaLabel?.value}
                                >
                                    {link.text.value}
                                </a>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};